import { type Manifest, type RouterConfig, PAGE_TYPE } from '@/types/manifest.ts';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.ENTRY,
    name: 'homepage',
    exclusiveRoutePath: '/',
    getComponent: () => import('./HomepageV2.vue'),
};

export const manifest: Manifest = {
    ...routerConfig,
};

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 去到 AI Drafting 主页
         */
        executeCommand(commandId: 'command:route:homepage'): void;
    }
}
